import { useEffect } from 'react';
import { Switch, Route, Redirect, useLocation } from 'react-router-dom';
import { IonPage, IonContent } from '@ionic/react';
import { ContentTabNav } from '../../components/content/ContentTabNav';
import { useBreadcrumbStore } from '../../store/useBreadcrumbStore';
import BadgesTab from './BadgesTab';
import CertificatesTab from './CertificatesTab';
import CertificationsTab from './CertificationsTab';
import CourseGroupsTab from './CourseGroupsTab';
import AdditionalContentTab from './AdditionalContentTab';
import CoursesTab from './CoursesTab';
import CourseDetailPage from './CourseDetailPage';

export default function ContentPage() {
  const location = useLocation();
  const setBreadcrumb = useBreadcrumbStore((s) => s.set);
  const isDetailPage = location.pathname === '/content/course-detail';

  useEffect(() => {
    if (!location.pathname.startsWith('/content')) return;
    if (!isDetailPage) {
      setBreadcrumb([{ label: 'Content' }]);
    }
  }, [location.pathname, isDetailPage, setBreadcrumb]);

  // Detail pages get their own layout (no tab nav)
  if (isDetailPage) {
    return <CourseDetailPage />;
  }

  return (
    <IonPage>
      <IonContent>
        <div className="p-4 sm:p-6 lg:p-8">
          <ContentTabNav />
          <div className="mt-4">
            <Switch>
              <Route exact path="/content">
                <Redirect to="/content/courses" />
              </Route>
              <Route exact path="/content/courses">
                <CoursesTab />
              </Route>
              <Route exact path="/content/certifications">
                <CertificationsTab />
              </Route>
              <Route exact path="/content/course-groups">
                <CourseGroupsTab />
              </Route>
              <Route exact path="/content/certificates">
                <CertificatesTab />
              </Route>
              <Route exact path="/content/badges">
                <BadgesTab />
              </Route>
              <Route exact path="/content/additional-content">
                <AdditionalContentTab />
              </Route>
            </Switch>
          </div>
        </div>
      </IonContent>
    </IonPage>
  );
}
